<template>
  <div class="container">
    <div class="selectconditons">
      <a-row :gutter="24">
        <a-col :xl="6" :lg="7" :md="8" :sm="24">
          <a-input
            ref="userid"
            v-model="inputGroup.userid"
            placeholder="用户id(userid)"
            @pressEnter=";(pagination.current = 1), getTableDate()"
          >
            <a-icon slot="prefix" type="user" />
            <a-tooltip slot="suffix" title="用户id(userid)">
              <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
            </a-tooltip>
          </a-input>
        </a-col>
        <a-col :xl="6" :lg="7" :md="8" :sm="24">
          <h-one-selec-tag
            style="width: 100%"
            v-model="inputGroup.smsType"
            placeholder="短信类型"
            dictCode="message_sms_type"
          />
        </a-col>
        <a-col :xl="6" :lg="7" :md="8" :sm="24">
          <h-one-selec-tag
            style="width: 100%"
            v-model="inputGroup.platform"
            placeholder="平台"
            dictCode="message_send_platform"
          />
        </a-col>
        <a-button type="primary" icon="search" @click=";(pagination.current = 1), getTableDate()">搜索</a-button>
        <a-button type="primary" icon="plus" style="margin-left: 1%" @click="openAddModal()">添加一组信息</a-button>
      </a-row>
    </div>
    <div class="selectresulttable">
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="false"
        :scroll="{ x: 1000 }"
        :loading="loading"
        bordered
      >
        <span slot="action" slot-scope="text, record">
          <!-- editIndustry -->
          <a-button type="link" @click="openAddModal(record)" size="small" style="margin-right: 3px">修改</a-button>
          <a-button type="link" style="color: #ff4d4f" @click="deleteIndustry(record)" size="small">删除</a-button>
        </span>
      </a-table>
      <div class="pageBar">
        <a-pagination
          style="margin-top: 1%; float: right"
          size="small"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
    <manageIndustryModal
      ref="manageIndustryModal"
      @ok=";(pagination.current = 1), getTableDate()"
    ></manageIndustryModal>
  </div>
</template>

<script>
import { delIndustry, getNewAllIndustry } from '@/api/api'
import moment from 'moment'
import { deleteAction } from '@/api/manage'
import JDictSelectTag from '../../components/dict/JDictSelectTag.vue'
import JMultiSelectTag from '../../components/dict/JMultiSelectTag.vue'
import HOneSelecTag from './modules/HOneSelecTag.vue'
import manageIndustryModal from './modules/manageIndustryModal.vue'
//表格字段名称
const columns = [
  {
    title: '账号名称',
    dataIndex: 'accountName',
    key: 'accountName',
    width: 100,
  },
  {
    title: '发送平台',
    dataIndex: 'platform_dictText',
    key: 'platform_dictText',
    width: 100,
  },
  {
    title: '短信类型',
    dataIndex: 'smsType_dictText',
    key: 'smsType_dictText',
    width: 100,
  },

  {
    title: '用户id',
    dataIndex: 'userid',
    key: 'userid',
    width: 80,
  },

  {
    title: '签名',
    dataIndex: 'signatures',
    key: 'signatures',
    width: 100,
  },
  {
    title: '备注',
    dataIndex: 'memo',
    key: 'memo',
    width: 150,
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 120,
    align: 'center',
  },
  {
    title: '修改时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 120,
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: 100,
  },
]

export default {
  components: { JDictSelectTag, JMultiSelectTag, HOneSelecTag, manageIndustryModal },
  data() {
    return {
      columns,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      //查询参数
      inputGroup: {
        platform: '',
        smsType: '',
        userid: '',
      },
      loading: false,
    }
  },
  mounted() {
    this.getTableDate()
  },
  methods: {
    openAddModal(record) {
      this.$refs.manageIndustryModal.edit(record)
    },
    //删除账号信息二步确认
    deleteIndustry(industry) {
      this.$antdConfirm({
        title: '是否删除短信类型为' + industry.type + '的账户信息?',
        content: (h) => (
          <div style="color:red;">
            <a-icon type="info-circle" style="margin-right:10px" />
            删除操作不可恢复的哦
          </div>
        ),
        okText: '是',
        okType: 'danger',
        cancelText: '点错啦',
        onOk: () => {
          this.doDelete(industry.id)
        },
        onCancel: () => {
          this.$message.success('感谢您的仁慈！')
        },
      })
    },
    //删除信息账号
    doDelete(id) {
      // let delDate = {
      //   id: id
      // }
      //    delIndustry(delDate).then(res => {
      //   if (res.success) {
      //     this.$message.success(res.message)
      //     this.getTableDate()
      //   } else {
      //     this.$message.error(res.message)
      //   }
      // })
      deleteAction('/base/busCommonMessageAccountNew/delete?id=' + id).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //页面换页重新获取表格数据
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getTableDate()
    },
    //页面容量修改时重新获取表格数据
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getTableDate()
    },
    //获取表格数据
    getTableDate() {
      this.loading = true
      let parms = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        platform: this.inputGroup.platform,
        smsType: this.inputGroup.smsType,
        userid: this.inputGroup.userid,
      }
      getNewAllIndustry(parms).then((res) => {
        this.data = res.result.records
        this.pagination.current = res.result.current
        this.pagination.total = res.result.total
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  background-color: #ffffff;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.titleLabel {
  float: right;
  padding-right: 10%;
}
.nullTips {
  color: red;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  margin: auto;
}
.rowStyle {
  height: 100%;
  margin-top: 15px;
}
.width-100 {
  width: 100%;
}
</style>
